module.exports = __webpack_public_path__ + "payu.jpg?e50f3acfb52837c3a9ce57556550408b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/payu.jpg
// module id = pecl
// module chunks = 46